import type { ReactNode } from "react";
import { FaChevronLeft } from "react-icons/fa";
import styles from "../../pages/GSTReconciliation/GSTReconciliation.module.scss";

interface GSTConnectionModalShellProps {
  isOpen?: boolean;
  onOverlayClick?: () => void;
  onBack?: () => void;
  backLabel?: string;
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
  footerVariant?: "default" | "api_setup";
}

export default function GSTConnectionModalShell({
  isOpen = true,
  onOverlayClick,
  onBack,
  backLabel = "Back",
  title,
  subtitle,
  children,
  footer,
  footerVariant = "default",
}: GSTConnectionModalShellProps) {
  if (!isOpen) return null;

  return (
    <div
      className={styles.connectModalOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onOverlayClick?.();
        }
      }}
    >
      <div className={styles.connectModal}>
        <div className={styles.connectModalBody}>
          {onBack ? (
            <button className={styles.connectModalBack} onClick={onBack}>
              <FaChevronLeft /> {backLabel}
            </button>
          ) : null}

          <div className={styles.connectModalHeader}>
            <div className={styles.connectModalTitle}>{title}</div>
            <div className={styles.connectModalSub}>{subtitle}</div>
          </div>

          {children}
        </div>

        {footer ? (
          <div
            className={`${styles.connectModalFooter} ${
              footerVariant === "api_setup" ? styles.apiSetupFooter : ""
            }`}
          >
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
